import React, { useEffect ,useState} from 'react';
import Navbar from '../nav/Navbar';
import './gallery.css'
import Footer from '../footer/Footer';
const images = [
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g1.jpg", alt: "Image 01" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g2.jpg", alt: "Image 02" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g9.jpg", alt: "Image 09" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g4.jpg", alt: "Image 04" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g3.jpg", alt: "Image 03" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g5.jpg", alt: "Image 05" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g8.jpg", alt: "Image 08" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g7.jpg", alt: "Image 07" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g10.jpg", alt: "Image 10" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g13.jpg", alt: "Image 13" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g14.jpg", alt: "Image 14" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g12.jpg", alt: "Image 12" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g6.jpg", alt: "Image 06" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g11.jpg", alt: "Image 11" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g15.jpg", alt: "Image 15" },
    { src: "https://download.kaabilfinance.com/kaabil+website+images/g16.jpg", alt: "Image 16" }
  ];
const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [lightboxImage, setLightboxImage] = useState("");
  const [lightboxAltImage, setLightboxAltImage] = useState("");

  // Function to open the lightbox with an image
  const openLightbox = (src, alt) => {
    setLightboxImage(src);
    setLightboxAltImage(alt);
  };

  // Function to close the lightbox
  const closeLightbox = () => {
    setLightboxImage("");
    setLightboxAltImage("");
  };
  return (
    <div>
      <Navbar />
      <div className='news_media' >
        <h1>Gallery</h1>
      </div>
     
        <div className='main_contact' style={{marginTop:"2rem"}}>
      
      <div className="gallery">
        {images.map((image, index) => (
          <button
            type="button"
            className="gallery__item"
            key={index}
            onClick={() => openLightbox(image.src, image.alt)}
          >
            <img className="gallery__image" src={image.src} alt={image.alt} />
          </button>
        ))}
      </div>

      {lightboxImage && (
        <div className="lightbox">
          <button
            type="button"
            className="lightbox__close-button"
            onClick={closeLightbox}
          >
            &times;
          </button>
          <img
            className="lightbox__image"
            src={lightboxImage}
            alt={lightboxAltImage}
          />
          <button
            type="button"
            className="lightbox__bg"
            onClick={closeLightbox}
          />
        </div>
      )}
    </div>
   
      <Footer />
    </div>

  );
};

export default ContactUs;
